import { render, staticRenderFns } from "./UserReferralsEdit.vue?vue&type=template&id=52bd88ae&"
import script from "./UserReferralsEdit.vue?vue&type=script&lang=js&"
export * from "./UserReferralsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports